import React from 'react';
import { HiBell } from 'react-icons/hi';
import SettingsSection from './SettingsSection';
import Toggle from '../common/Toggle';
import NumberInput from '../common/NumberInput';
import Select from '../common/Select';
import { useSettings } from '../../context/SettingsContext';

const NotificationSettings = () => {
  const { settings, updateSettings } = useSettings();
  const { notifications } = settings;

  const channelOptions = [
    { value: 'browser', label: '브라우저 알림' },
    { value: 'email', label: '이메일 (Mock)' },
    { value: 'sms', label: 'SMS (Mock)' },
  ];

  return (
    <SettingsSection title="알림 설정" icon={HiBell}>
      {/* 거래 알림 */}
      <div>
        <h4 className="text-sm font-semibold text-gray-300 mb-3">거래 알림</h4>
        <div className="space-y-3">
          <Toggle
            label="주문 체결 시 알림"
            checked={notifications.notifyOnOrder}
            onChange={(value) => updateSettings('notifications', 'notifyOnOrder', value)}
          />
          <Toggle
            label="진입 시 알림"
            checked={notifications.notifyOnEntry}
            onChange={(value) => updateSettings('notifications', 'notifyOnEntry', value)}
          />
          <Toggle
            label="청산 시 알림"
            checked={notifications.notifyOnExit}
            onChange={(value) => updateSettings('notifications', 'notifyOnExit', value)}
          />
        </div>
      </div>

      {/* 손익 알림 */}
      <div>
        <h4 className="text-sm font-semibold text-gray-300 mb-3">손익 알림</h4>
        <div className="space-y-3">
          <Toggle
            label="익절 시 알림"
            checked={notifications.notifyOnProfit}
            onChange={(value) => updateSettings('notifications', 'notifyOnProfit', value)}
          />
          <Toggle
            label="손절 시 알림"
            checked={notifications.notifyOnLoss}
            onChange={(value) => updateSettings('notifications', 'notifyOnLoss', value)}
          />
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-3">
            <NumberInput
              label="수익 알림 임계값"
              value={notifications.profitThreshold}
              onChange={(value) => updateSettings('notifications', 'profitThreshold', value)}
              min={0}
              max={10000000}
              step={10000}
              unit="원"
            />
            <NumberInput
              label="손실 알림 임계값"
              value={notifications.lossThreshold}
              onChange={(value) => updateSettings('notifications', 'lossThreshold', value)}
              min={0}
              max={10000000}
              step={10000}
              unit="원"
            />
          </div>
        </div>
      </div>

      {/* 시스템 알림 */}
      <div>
        <h4 className="text-sm font-semibold text-gray-300 mb-3">시스템 알림</h4>
        <div className="space-y-3">
          <Toggle
            label="시스템 오류 알림"
            checked={notifications.notifyOnError}
            onChange={(value) => updateSettings('notifications', 'notifyOnError', value)}
          />
          <Toggle
            label="API 연결 끊김 알림"
            checked={notifications.notifyOnApiDisconnect}
            onChange={(value) => updateSettings('notifications', 'notifyOnApiDisconnect', value)}
          />
          <Toggle
            label="일일 목표 달성 알림"
            checked={notifications.notifyOnDailyTarget}
            onChange={(value) => updateSettings('notifications', 'notifyOnDailyTarget', value)}
          />
        </div>
      </div>

      {/* 알림 채널 */}
      <div>
        <h4 className="text-sm font-semibold text-gray-300 mb-3">알림 채널</h4>
        <div className="space-y-4">
          <Select
            label="알림 채널"
            value={notifications.notificationChannel}
            onChange={(value) => updateSettings('notifications', 'notificationChannel', value)}
            options={channelOptions}
          />
          <Toggle
            label="알림 소리 활성화"
            checked={notifications.notificationSound}
            onChange={(value) => updateSettings('notifications', 'notificationSound', value)}
          />
        </div>
      </div>
    </SettingsSection>
  );
};

export default NotificationSettings;
